import React, { useEffect, useContext, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import styled from 'styled-components';
import { PrayerPartnerContext } from "../contexts/PrayerPartnerContext";
import { Pagination } from "../components/pagination";
import {
    Filter,
    CALL_LOG_API_PARAMS,
    getCallLogsFilterStringFromUrl,
    parseCallLogsFilterString,
} from "../components/filter";
import moment from 'moment-timezone';
import { resolveRecordingUrl } from '../helpers/utils';
import { MdClear } from 'react-icons/md';
import { SearchWrapper } from '../components/filter';

const FILTER_PARAM = "filter";

export const CallLogsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const {callLogs, fetchCallLogs, totalLogsCount} = useContext(PrayerPartnerContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [filterString, setFilterString] = useState(() =>
        getCallLogsFilterStringFromUrl(searchParams, FILTER_PARAM)
    );
    const prevFilterString = useRef(filterString);

    useEffect(() => {
        fetchCallLogs(currentPage, filterString);
        window.scrollTo({top: 0, behavior: "smooth"});
    }, [currentPage, filterString]);

    useEffect(() => {
        if (prevFilterString.current !== filterString) {
            prevFilterString.current = filterString;
            setCurrentPage(1);
        }
    }, [filterString]);

    // Keep URL in sync with filter so it survives refresh
    useEffect(() => {
        const next = new URLSearchParams(searchParams);
        next.delete(FILTER_PARAM);
        CALL_LOG_API_PARAMS.forEach((key) => next.delete(key));

        if (filterString) {
            new URLSearchParams(filterString).forEach((value, key) => {
                next.set(key, value);
            });
        }

        setSearchParams(next, { replace: true });
    }, [filterString]);

    return (
        <div className="m-3">
            <Filter
                setFilterString={setFilterString}
                page={"callLogs"}
                initialFilterString={getCallLogsFilterStringFromUrl(searchParams, FILTER_PARAM)}
            />
            {/* Filter badges are rendered inside the Filter component to avoid duplication */}
            {callLogs &&
                <Table className="p-4">
                    <thead>
                        <tr>
                            <th>Call Date & Time</th>
                            <th>Agent's Name</th>
                            <th>Caller Number</th>
                            <th>Organization Number</th>
                            <th>Recording</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            callLogs.map((callLog) =>{
                                const recordingUrl = resolveRecordingUrl(callLog.recording);
                                return (
                                    <tr key={callLog.task_sid}>
                                        <td>
                                            {moment.utc(callLog.date).tz('America/New_York').format('MM/DD/YYYY HH:mm:ss')}
                                        </td>
                                        <td>{callLog.agent_full_name}</td>
                                        <td>{callLog.user_number}</td>
                                        <td>{callLog.twilio_number}</td>
                                        <td>
                                            {recordingUrl ? (
                                                <audio controls className="m-0 p-0">
                                                    <source src={recordingUrl} type="audio/ogg"/>
                                                    <source src={recordingUrl} type="audio/mpeg"/>
                                                    Your browser does not support the audio element.
                                                </audio>
                                            ) : null}
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            }
            <Pagination totalCount={totalLogsCount} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
    )
}

const Table = styled.table`
    width: 100%;
    border: 1px solid #00323B;
    thead{
        flex-shrink: 0;
        border-bottom: 1px solid #00323B;
        background-color: #F1F1F1;
        color: #178B96;
        text-align: center;
    }
    tbody{
        text-align: center;
        tr{
            text-align: center;
        }
        td{
            padding: 0.5em;
            border-bottom: 1px solid #00323B;
            background-color: #fff;
            color: #178B96;
        }
    }
`;
